import { useCallback } from 'react';
import { navigate } from 'gatsby';
import { useTranslation } from 'react-i18next';
import { useLocation } from '@reach/router';
import { pages } from '../data/pages';

/**
 * Hook to toggle between languages (e.g., 'en' and 'pl').
 * Returns a function that switches the language and navigates to the corresponding page.
 *
 * @author Ryszard Trojnacki
 */
export function useToggleLanguage() {
  const { i18n } = useTranslation();
  const language = i18n.language || 'en';
  const location = useLocation();
  
  return useCallback(() => {
    const newLanguage = language === 'en' ? 'pl' : 'en';
    console.log('Path', location.pathname, 'Language', language);
    console.log('Switching language from', language, 'to', newLanguage);
    
    const currentPath = location.pathname;
    const page = pages.find(p => p[language] === currentPath);
    
    if (!page) {
      console.error(`No matching page found for path: ${currentPath} in language: ${language}`);
      return;
    }
    
    const newPath = page[newLanguage];
    console.log(`Navigating to ${newPath} for language ${newLanguage}`);
    
    navigate(newPath);
  }, [location.pathname, language]);
}